import React from 'react';
import { NavLink } from 'react-router-dom';

const destinations = [
    { tab: 'activity', label: 'Activity' },
    { tab: 'beers', label: 'Beers' },
    { tab: 'cellar', label: 'Cellar' },
    { tab: 'profile', label: 'Profile' },
];

const UserNavigation = () => {
    return (
        <nav className="app-navigation" aria-label="CRAFT account navigation">
            {destinations.map(({ tab, label }) => (
                <NavLink key={tab} to={`/app/${tab}`}>
                    {label}
                </NavLink>
            ))}
        </nav>
    );
};

export default UserNavigation;
